/**
 * @file
 * @fileOverview This file contains the main entry point for the application.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

/*import * as LazyLoaders from './lazyLoaders.js';

export const objectRegistry = LazyLoaders.objectRegistryProxy;
export const VirtualScreen = LazyLoaders.virtualScreenProxy;
export const CustomButton = LazyLoaders.customButtonProxy;
export const CustomTextInput = LazyLoaders.customTextInputProxy;
export const HandDetection = LazyLoaders.handDetectionProxy;
export const SocketIOClient = LazyLoaders.socketIOClientProxy;
export const ImageProcessor = LazyLoaders.imageProcessorProxy;
export const CustomToggle = LazyLoaders.customToggleProxy;
export const SpeechRecognizer = LazyLoaders.speechRecognizerProxy;
export const HTMLToCanvasTexture = LazyLoaders.htmlToCanvasTextureProxy;*/

import objectRegistry from './ObjectRegistry.js';
import VirtualScreen from './virtualScreen.js';
import CustomButton from './UI/VirtualButton.js';
import CustomTextInput from './UI/virtualTextBox.js';
import HandDetection from './Util/handDetection.js';
import SocketIOClient from './Util/socketio.js';
import ImageProcessor from './Util/videoPreProcessing.js';
import CustomToggle from './UI/virtualToggleButton.js';
import SpeechRecognizer from './Util/webSpeechRecognition.js';
import HTMLToCanvasTexture from './UI/HtmlCanvasTexture.js';
import TextBoxAframe from './UI/aframeTextBox.js';
import OnlineAudioStreamer from './Util/OnlineAudioStreamer.js';
import SpeechSynthesizer from './Util/webSpeechSynth.js';
import AppDataManager from './Util/appFetcher.js';
import GLBCacheManager from './Util/GLBcacheManager.js';
import AframeVideoJs from './Util/videoPlayer.js';
import { componentManager } from './UI/AframeComponentManager.js';
import PlayCanvasTextureRenderer from './Util/playCanvasTexture.js'
import MixedReality from './MixedReality/mixed-reality.js'
import AFrameObjectBuilder from './Util/Scripting/aframeScriptingUtil.js';
import TwitchIntegration from './Util/twitchIntegration.js';
import asmManager from './Util/AssemblyScript/asm-manager.js';
import UnityGameLoader from './Util/Apps/UnityEngineLoader.js';
//import CoreClass from './cpp/core/CoreClass.cpp';
import SoundShader from './Util/SoundManager.js';
import ImageCompressor from './Util/DataCompressor.js';
import MarkdownDisplay from './UI/VersonaMarkdownScreen.js';
import createVirtualScreenWithMarkdown from './UI/CreateVersonaMarkdownScreen.js';
import './public/main.css';

// Load all components
//componentManager.loadComponents();

const app = {
  objectRegistry,
  VirtualScreen,
  HandDetection,
  CustomButton,
  CustomTextInput,
  SocketIOClient,
  ImageProcessor,
  CustomToggle,
  SpeechRecognizer,
  HTMLToCanvasTexture,
  TextBoxAframe,
  OnlineAudioStreamer,
  SpeechSynthesizer,
  AppDataManager,
  GLBCacheManager,
  AframeVideoJs,
  PlayCanvasTextureRenderer,
  MixedReality,
  AFrameObjectBuilder,
  TwitchIntegration,
  asmManager,
  UnityGameLoader,
  SoundShader,
  ImageCompressor,
  MarkdownDisplay,
  createVirtualScreenWithMarkdown
 // CoreClassBridge
};

export default app;
